import { resetPasswordForEmail } from "../../api/forget-password/index";

export const forgetPasswordForEmail = async (email: string) => {
  const response = await resetPasswordForEmail(email);
  return response;
};
